import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminNotFoundLog from "@/pages/admin/AdminNotFoundLog";

export const Route = createFileRoute("/admin/not-found-log")({
  component: () => (
    <ProtectedRoute>
      <AdminNotFoundLog />
    </ProtectedRoute>
  ),
});
